/**
 * Get Cart Use Case
 */

import { ICartService } from '@/domain/services/cart.service.interface';
import { CartEntity } from '@/domain/entities/cart.entity';

export interface GetCartInput {
  token: string;
}

export interface GetCartOutput {
  cart: CartEntity | null;
}

export class GetCartUseCase {
  constructor(private readonly cartService: ICartService) {}

  async execute(input: GetCartInput): Promise<GetCartOutput> {
    if (!input.token || input.token.trim() === '') {
      throw new Error('Cart token is required');
    }

    const cart = await this.cartService.getCart(input.token);

    return {
      cart,
    };
  }
}

